export interface ApplySurveyStructureSelectionArea {
  id: string;
  chipIds: string[];
}

export interface ApplySurveyStructureSelectionItem {
  id: string;
  areaId: string;
  chipIds: string[];
}

export function applySurveyStructureSelection(params: {
  surveyChips: string[];
  areas: ApplySurveyStructureSelectionArea[];
  items: ApplySurveyStructureSelectionItem[];
}): {
  areaResults: Map<string, boolean>;
  itemResults: Map<string, boolean>;
} {
  const surveyChips = params.surveyChips ?? [];
  const hasSurveyChips = surveyChips.length > 0;
  const surveyChipSet = new Set(surveyChips);

  const areaResults = new Map<string, boolean>();
  for (const area of params.areas ?? []) {
    const chipIds = area.chipIds ?? [];
    const included =
      !hasSurveyChips || chipIds.some((id) => surveyChipSet.has(id));
    areaResults.set(area.id, included);
  }

  const itemResults = new Map<string, boolean>();
  for (const item of params.items ?? []) {
    const isAreaIncluded = areaResults.get(item.areaId) !== false;
    if (!isAreaIncluded) {
      itemResults.set(item.id, false);
      continue;
    }

    const chipIds = item.chipIds ?? [];
    const included =
      !hasSurveyChips || chipIds.some((id) => surveyChipSet.has(id));
    itemResults.set(item.id, included);
  }

  return { areaResults, itemResults };
}
